import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Paths } from 'shared/routes/paths';
import { DataType } from 'shared/types/data-type';
import { ID } from 'shared/types/id';
import { replaceUrlParams } from 'shared/utils/replace-url-params';
import { useTheme } from 'styled-components';

import * as Styled from './cta-container.style';

export type CtaContainerProps = {
  id: ID;
  title: string;
  onClick?: (id: ID) => void;
  isFrozen?: boolean;
  children: React.ReactNode;
  preventInteraction?: boolean;
};

export const CtaContainer: React.FC<CtaContainerProps> = ({
  id,
  title,
  onClick,
  isFrozen,
  children,
  preventInteraction,
}) => {
  const theme = useTheme();
  const navigate = useNavigate();

  if (preventInteraction) {
    return (
      <Styled.ClickContainer
        data-component-type={DataType.Goal}
        data-id={id}
        data-title={title}
      >
        {children}
      </Styled.ClickContainer>
    );
  }

  if (isFrozen || onClick) {
    const _onClick = onClick ? () => onClick(id) : undefined;
    return (
      <Styled.ClickContainer
        data-component-type={DataType.Goal}
        data-id={id}
        data-title={title}
        onClick={_onClick}
      >
        {children}
      </Styled.ClickContainer>
    );
  }

  if (theme.isTouchDevice) {
    const _onClick = () => navigate(replaceUrlParams(Paths.GoalDetail, { id }));
    return (
      <Styled.ClickContainer
        data-component-type={DataType.Goal}
        data-id={id}
        data-title={title}
        onClick={_onClick}
      >
        {children}
      </Styled.ClickContainer>
    );
  }

  const preventDefault = (e: React.MouseEvent) => {
    if (e.metaKey || e.shiftKey || e.ctrlKey) {
      e.preventDefault();
      return;
    }

    e.stopPropagation();
  };

  return (
    <Styled.LinkContainer
      data-component-type={DataType.Goal}
      data-id={id}
      data-title={title}
      to={replaceUrlParams(Paths.GoalDetail, { id })}
      onClick={preventDefault}
    >
      {children}
    </Styled.LinkContainer>
  );
};
